/**
 * Service worker registration.
 *
 * - Production-only: SW is gated on NODE_ENV==='production' to keep
 *   craco/CRA dev hot-reload friction-free.
 * - On 'waiting' (a new SW has installed behind the active one), surfaces
 *   a sonner toast with a "Reload" action that posts SKIP_WAITING and then
 *   reloads once the new SW takes control.
 */
import { Workbox } from "workbox-window";
import { toast } from "sonner";

let wb = null;

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // CRA's homepage default is '/', so the SW lives at /service-worker.js.
  const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

  wb = new Workbox(swUrl, { scope: "/" });

  const promptUserToReload = () => {
    let toastId;
    const handleReload = () => {
      wb.addEventListener("controlling", () => {
        window.location.reload();
      });
      wb.messageSkipWaiting();
    };
    toastId = toast.message("A new version is available", {
      description: "Reload to update ExpenseReconcile.",
      duration: Infinity,
      action: {
        label: "Reload",
        onClick: handleReload,
      },
    });
    return toastId;
  };

  wb.addEventListener("waiting", promptUserToReload);
  wb.addEventListener("externalwaiting", promptUserToReload);

  wb.register().catch((err) => {
    // Non-fatal; the app still works without a SW.
    // eslint-disable-next-line no-console
    console.warn("[sw] registration failed:", err);
  });
}
